import { useNavigate } from 'react-router-dom';
import { Menu } from 'lucide-react';
import { Button, Drawer, useOverlayState } from '@heroui/react';
import { AppBrand } from '../../../components/ui/app-brand';
import { ThemeToggle } from '../../../components/ui/theme-toggle';
import { navDrawerDialogClassName } from '../../../components/ui/side-drawer-classes';
import { useAuth } from '../../../hooks/useAuth';
import { defaultAppRoute } from '../../../shell/nav-items';

const NAV_LINKS = [
  { href: '#produto', label: 'Produto' },
  { href: '#como-funciona', label: 'Como funciona' },
  { href: '#sindicos', label: 'Para síndicos' },
  { href: '#faq', label: 'FAQ' },
] as const;

export function LandingNav() {
  const navigate = useNavigate();
  const menuState = useOverlayState();
  const { userDoc, loading } = useAuth();
  const isSignedIn = !loading && !!userDoc;

  const goToApp = () => navigate(isSignedIn ? defaultAppRoute : '/login');

  return (
    <>
      <header className="sticky top-0 z-40 border-b border-separator bg-background/80 backdrop-blur-md">
        <div className="mx-auto flex h-16 max-w-6xl items-center gap-3 px-4 sm:px-6">
          <Button
            isIconOnly
            variant="ghost"
            className="shrink-0 lg:hidden"
            aria-label="Abrir menu"
            onPress={menuState.open}
          >
            <Menu size={20} />
          </Button>

          <a href="#inicio" className="min-w-0">
            <AppBrand iconSize={18} markClassName="size-8 rounded-md" />
          </a>

          <nav className="hidden flex-1 items-center justify-center gap-5 lg:flex" aria-label="Seções">
            {NAV_LINKS.map((link) => (
              <a
                key={link.href}
                href={link.href}
                className="text-sm font-medium text-muted transition-colors hover:text-foreground"
              >
                {link.label}
              </a>
            ))}
          </nav>

          <div className="ml-auto flex shrink-0 items-center gap-1 sm:gap-2">
            <ThemeToggle />
            {isSignedIn ? (
              <Button variant="primary" onPress={goToApp}>
                Abrir o app
              </Button>
            ) : (
              <>
                <Button variant="ghost" className="hidden lg:flex" onPress={() => navigate('/login')}>
                  Entrar
                </Button>
                <Button variant="primary" onPress={() => navigate('/login')}>
                  Criar conta
                </Button>
              </>
            )}
          </div>
        </div>
      </header>

      <Drawer state={menuState}>
        <Drawer.Backdrop isDismissable variant="blur">
          <Drawer.Content placement="left">
            <Drawer.Dialog className={navDrawerDialogClassName}>
              <Drawer.Header>
                <Drawer.Heading>Link Park</Drawer.Heading>
                <Drawer.CloseTrigger />
              </Drawer.Header>
              <Drawer.Body className="flex flex-col gap-1">
                {NAV_LINKS.map((link) => (
                  <a
                    key={link.href}
                    href={link.href}
                    className="rounded-lg px-3 py-2 text-sm font-medium text-foreground hover:bg-default"
                    onClick={() => menuState.close()}
                  >
                    {link.label}
                  </a>
                ))}
                <Button className="mt-4" variant="primary" onPress={() => {
                  menuState.close();
                  goToApp();
                }}>
                  {isSignedIn ? 'Abrir o app' : 'Criar conta'}
                </Button>
              </Drawer.Body>
            </Drawer.Dialog>
          </Drawer.Content>
        </Drawer.Backdrop>
      </Drawer>
    </>
  );
}
